import React from "react";
import GenderRepresentation from "./GenderRepresentation";
import MunicipalCouncil from "./MunicipalCouncil";

import { locales } from "../../locales";
import CandidateList from "../Canditates/CandidateList";
import ElectedList from "./ElectedList";
import { getDataSource } from "../../services/api";
import {
  deigrengCase,
  formatString,
  getSeatNumber,
} from "../../utils/communesUtils";

const partiesLogosSize = {
  deigreng: {
    w: 53,
    h: 42,
  },
  lsap: {
    w: 44,
    h: 44,
  },
  csv: {
    w: 101,
    h: 49,
  },
  dp: {
    w: 62,
    h: 41,
  },
  schetterbierger: {
    w: 50.22,
    h: 38.88,
  },
  independant: {
    w: 53,
    h: 53,
  },
  arleit: {
    w: 40,
    h: 40,
  },
  ebl: {
    w: 43.43,
    h: 41.99,
  },
  arequipe: {
    w: 150,
  },
};
const Politic = ({
  data,
  commune,
  langId,
  isDesktop,
  communeId,
  hasElectionSystemChanged,
  resultsData,
}) => {
  const {
    // parties,
    gender,
    coalitions,
    coalitionsGender,
    typeOfMunicipality,
    elected,
    // majorz,
    seats,
    municipalCouncil,
  } = data;

  let coalitionData = (coalitions || "").split("/");
  const isSmallCommune = typeOfMunicipality === locales["fr"].communeTypeSmall;
  const isUniqueRulingParty = coalitionData.length === 1;

  let currentSeats = {};

  if (!isSmallCommune) {
    currentSeats = getSeatNumber(
      resultsData["2023"].results.resultats.listes
    ).reduce((obj, item) => {
      obj[deigrengCase(item.party)] = item.seats;
      return obj;
    }, {});
  }

  // special cases
  if (communeId === "83") {
    coalitionData[0] = "Schëtter Bierger";
  }
  const topElected = elected.filter(
    (item) => item.function !== "Conseiller communal"
  );
  const partyLogoUrl = (party) => {
    if (party === "Är Équipe" && data.id === 33) {
      return `${getDataSource()}/parties/arequipe_33.svg`;
    }
    if (party === "Är Leit" && data.id === 9) {
      return `${getDataSource()}/parties/bissen_arleit.svg`;
    }
    if (party === "Indépendant" && langId === "de") {
      return `${getDataSource()}/parties/independant-de.svg`;
    }
    if (party === "Indépendant" && langId === "fr") {
      return `${getDataSource()}/parties/independant-fr.svg`;
    }
    return `${getDataSource()}/parties/${formatString(party)}.svg`;
  };

  return (
    <div className="flex flex-col mt-20" id="population-section">
      {/* <span className="text-left font-semibold text-32 leading-38">
        {locales[langId].communeInNumbers}
        wort-medium:mt-[120px]
      </span> */}
      <span className="text-left font-bold mb-3 text-22 leading-26 uppercase wort-medium:text-32 wort-medium:leading-38">
        {locales[langId].politic}
      </span>
      <hr className="h-[2px] w-full bg-[#d3d3d3]" />
      <div className="flex flex-col mt-8 justify-between wort-medium:px-5 wort-medium:flex-row wort-medium:h-[493px]">
        {!isSmallCommune && !hasElectionSystemChanged && (
          <>
            <div className="flex flex-col wort-medium:w-[366px]">
              <span className="text-22 leading-26 text-left font-bold ">
                {locales[langId].municipalCouncilTitle}
                {/* {commune} */}
              </span>
              <span className="text-lg text-left my-3 leading-20">
                {locales[langId].municipalCouncilDescription}
              </span>
              <div className="mt-5 h-[365px] wort-medium:h-[315px]">
                {municipalCouncil && (
                  <MunicipalCouncil
                    data={currentSeats}
                    isDesktop={isDesktop}
                    langId={langId}
                  />
                )}
              </div>
              <span className="text-xs text-black-rgba mt-2">
                {locales[langId].references[3]} |{" "}
                {locales[langId].references[2]}
              </span>
            </div>
            <div className="flex flex-col pt-20 wort-medium:w-[366px] wort-medium:pt-0">
              <span className="text-22 leading-26 text-left font-bold ">
                {locales[langId].municipalCouncilByGender}
              </span>
              <span className="text-lg text-left my-3 leading-20">
                {locales[langId].municipalCouncilByGenderDescription}
              </span>
              <div className="mt-5 h-[324px] wort-medium:h-[315px]">
                <GenderRepresentation
                  data={gender}
                  coalitionsGender={coalitionsGender}
                  langId={langId}
                  isDesktop={isDesktop}
                />
              </div>
              <span className="text-xs text-black-rgba mt-2">
                {locales[langId].references[3]} |{" "}
                {locales[langId].references[2]}
              </span>
            </div>
          </>
        )}
        {hasElectionSystemChanged && (
          <>
            <div className="flex flex-col wort-medium:w-[766px]">
              <span className="text-22 text-left font-bold ">
                {locales[langId].municipalCouncilTitleSmallCommune}
              </span>
              <span className="text-lg text-left my-3 leading-20">
                {locales[langId].municipalCouncilDescriptionSmallCommune}
              </span>

              <ElectedList
                data={municipalCouncil}
                langId={langId}
                elected={elected}
                isDesktop={isDesktop}
                seats={seats}
              />
            </div>
          </>
        )}
        {isSmallCommune && (
          <>
            <div className="flex flex-col wort-medium:w-[766px]">
              <span className="text-22 text-left font-bold ">
                {locales[langId].municipalCouncilTitleSmallCommune}
              </span>
              <span className="text-lg text-left my-3 leading-20">
                {locales[langId].municipalCouncilDescriptionSmallCommune}
              </span>

              <ElectedList
                data={municipalCouncil}
                langId={langId}
                elected={elected}
                isDesktop={isDesktop}
                seats={seats}
              />
            </div>
          </>
        )}
        <div className="flex flex-col wort-medium:w-[300px] wort-medium:pt-0 pt-4">
          <span className="text-22 leading-26 text-left font-bold">
            {isSmallCommune || hasElectionSystemChanged
              ? locales[langId].coalitionSmallCommune
              : isUniqueRulingParty
              ? locales[langId].governingParty
              : locales[langId].coalitionBigCommune}
          </span>
          {!isSmallCommune && (
            <div className={`flex flex-row justify-between mt-4 h-[62px]`}>
              {coalitionData.map((item, index) => {
                return (
                  <React.Fragment key={index}>
                    <img
                      src={`${partyLogoUrl(item)}`}
                      alt={item}
                      width={partiesLogosSize[formatString(item)]?.w}
                      height={partiesLogosSize[formatString(item)]?.h}
                    />
                    {index < coalitionData.length - 1 && item !== "Är Leit" ? (
                      <div className="border-r-2 border-gray-200 h-full" />
                    ) : null}
                  </React.Fragment>
                );
              })}
            </div>
          )}
          <CandidateList data={topElected} langId={langId} />
        </div>
      </div>
    </div>
  );
};

export default Politic;
